import { atom } from 'recoil';

import { IDestination } from '.';

export const DestinationsState = atom<IDestination>({
  key: 'destinations',
  default: {} as IDestination,
});

export const RawDestinationsState = atom<IDestination>({
  key: 'raw-destinations',
  default: {} as IDestination,
});

export const LoadingDestinationState = atom<boolean>({
  key: 'loading-destinations-list',
  default: false,
});

export const LoadedDestinationState = atom<boolean>({
  key: 'loaded-destinations-list',
  default: false,
});

export const SearchDestinationState = atom<string>({
  key: 'search-destinations',
  default: '',
});

export const FoldersState = atom<any>({
  key: 'folders-destination',
  default: [],
});

export const IsDestinationDisconnectState = atom<boolean>({
  key: 'is-destination-disconnect',
  default: false,
});
